// src/utils/validations.js

// دالة التحقق من صيغة الإيميل
export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

// دالة التحقق من الحقل غير الفارغ
export const validateRequired = (value) => {
  console.log("🚀 ~ validateRequired ~ value:", value);
  if (typeof value === "string") return value.trim() !== "";
};

// دالة التحقق من تطابق كلمة السر
export const validatePasswordMatch = (password, confirmPassword) => {
  return password === confirmPassword;
};
